import FItem from '.';

export default class FItemBoolean extends FItem {
  set(value) {
    super.set(!!value);
  }
}
